import { ColDef, ISelectCellEditorParams } from 'ag-grid-community';
export const SalesItemsColumnDef: ColDef[] = [
  {
    headerName: '#',
    width: 90,
    rowDrag: true,
    valueGetter: function (params) {
      return +params.node.id + 1;
    },
  },
  {
    // Service Date
    headerName: 'Service Date',
    field: 'service_date',
    editable: true,
    resizable: true,
    width: 125,
    cellEditor: 'agDateCellEditor',
    cellRenderer: (data) => {
      return data.value ? new Date(data.value).toLocaleDateString() : '';
    },
  },
  {
    // Product/Service
    headerName: 'Product/Service',
    field: 'product_service',
    cellEditor: 'productServiceAutocomplete',
    editable: true,
    resizable: true,
    width: 150,
  },
  {
    // Description
    headerName: 'Description',
    field: 'description',
    editable: true,
    resizable: true,
    flex: 1,
    tooltipField: 'description',
  },
  {
    // Qty
    headerName: 'Qty',
    field: 'qty',
    editable: true,
    resizable: true,
    width: 75,
    cellClassRules: {
      'qty-warning': params => params.data && params.data.qty_available === false
    },
    cellEditor: 'agNumberCellEditor',
    cellEditorParams: {
        precision: 0, // No decimal places (whole numbers only)
      }
  },
  {
    // Rate
    headerName: 'Rate',
    field: 'rate',
    editable: true,
    resizable: true,
    width: 100,
    valueFormatter: function (params) {
      if (params.value) {
        return '$' + params.value;
      } else {
        return null;
      }
    },
  },
  {
    // Amount
    headerName: 'Amount',
    field: 'amount',
    resizable: true,
    width: 100,
    tooltipField: 'amount',
    valueFormatter: function (params) {
      if (params.value) {
        return '$' + params.value.toFixed(2);
      } else {
        return null;
      }
    },
  },
  {
    // Tax
    headerName: 'Tax',
    field: 'tax',
    editable: true,
    resizable: true,
    width: 75,
    cellRenderer: function (params) {
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.checked = !!params.value;
      input.addEventListener('change', function () {
        // setDataValue mutates the row AND fires cellValueChanged, which the
        // SalesComponent uses to re-run calculateTotals() so the sales tax
        // line and grand total reflect the new taxable status immediately.
        params.node.setDataValue('tax', input.checked);
      });
      return input;
    },
  },
    {
    // Qty Available
    headerName: 'qty_available',
    field: 'qty_available',
    width: 75,
    hide: true,
    valueGetter: () => true
  },
];
